import { RoutingModule, RoutingModuleV2 } from 'modules/api';
import { apiClient } from 'modules/apiClient';
import { Route, RouteV2, RoutingFiles } from '../types';
import { RouteWaypointCoordinates } from 'modules/route/types';

type SubmitNewRoutingProps = {
  models: string[];
  waypoints: RouteWaypointCoordinates[];
  name: string;
  boatId: number;
  startTime?: string;
  windSpeedCorrections?: Record<string, unknown>;
  maxWind?: number;
  maxWave?: number;
  sailChangePenalty?: number;
  gybePenalty?: number;
  tackPenalty?: number;
  waveCorrection?: number;
  polarSpreadCalculation?: boolean;
  obeyExclusionZones?: boolean;
  polarEfficiency?: number;
  inclusionZoneId?: number;
  deviceId?: string;
};

const submitNewRoutingApiCall = async (
  data: SubmitNewRoutingProps,
): Promise<void> => {
  await apiClient.post(RoutingModule.Base, data);
};

const submitNewRoutingV2ApiCall = async (
  data: SubmitNewRoutingProps,
): Promise<void> => {
  await apiClient.post(RoutingModuleV2.Base, data);
};

const listAllServerRoutings = async (
  boatId: number,
  deviceId: string | undefined,
): Promise<Route[]> => {
  const response = await apiClient.get(RoutingModule.List, {
    params: { boatId, deviceId },
  });
  return response.data;
};

const listAllServerRoutingsV2 = async (
  boatId: number,
  deviceId: string | undefined,
): Promise<RouteV2[]> => {
  const response = await apiClient.get(RoutingModuleV2.List, {
    params: { boatId, deviceId },
  });
  return response.data;
};

const getRouting = async (
  routingId: number | string,
): Promise<RoutingFiles> => {
  const response = await apiClient.get(`${RoutingModule.Base}/${routingId}`);
  return response.data;
};

const getRoutingV2 = async (
  routingId: number | string,
): Promise<RoutingFiles> => {
  const response = await apiClient.get(`${RoutingModuleV2.Base}/${routingId}`);
  return response.data;
};

const deleteServerRouting = async (routingId: string): Promise<void> => {
  await apiClient.delete(`${RoutingModule.Base}/${routingId}`);
};

const deleteServerRoutingV2 = async (routingId: string): Promise<void> => {
  await apiClient.delete(`${RoutingModuleV2.Base}/${routingId}`);
};

export const RoutingApi = {
  submitNewRoutingApiCall,
  submitNewRoutingV2ApiCall,
  listAllServerRoutings,
  listAllServerRoutingsV2,
  getRouting,
  getRoutingV2,
  deleteServerRouting,
  deleteServerRoutingV2,
};
